<div class="location-input-editor" [formGroup]="optionsForm">
  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Type</label>
    <pdq-radio-group formControlName="type">
      <pdq-radio-button [value]="locationInputType.FULL_ADDRESS" text="Full Address"></pdq-radio-button>
      <pdq-radio-button [value]="locationInputType.ZIP_ONLY" text="Zip code only"></pdq-radio-button>
    </pdq-radio-group>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Empty State Description</label>
    <pdq-input formControlName="emptyStateDescription" placeholder="Enter your location for an exact date"> </pdq-input>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Field Placeholder Text</label>
    <pdq-input formControlName="fieldPlaceholder" placeholder="Enter your address"> </pdq-input>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Button Label</label>
    <pdq-input formControlName="buttonLabel" placeholder="Check shipping"></pdq-input>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Button Color</label>
    <pdq-input-color
      [control]="optionsForm.get('buttonColor')"
      [formControl]="optionsForm.get('buttonColor')"
      label=""></pdq-input-color>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">'Change Address' Link Text</label>
    <pdq-input formControlName="changeAddressLinkText" placeholder="Change"> </pdq-input>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">'Delivering to' Text</label>
    <pdq-input formControlName="deliveringToText" placeholder="Delivering to"></pdq-input>
  </div>

  <div class="location-input-editor__field">
    <fallback-address-input [addressControl]="optionsForm.get('fallbackAddress')"></fallback-address-input>
  </div>

  <div class="location-input-editor__inline-field">
    <pdq-checkbox formControlName="autoDetect" label="Auto-detect location for guest visitors"></pdq-checkbox>
  </div>

  <div class="location-input-editor__section-title">Error message (invalid input)</div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Message</label>
    <pdq-input formControlName="errorMessage" placeholder="We couldn't find what you're looking for, please try again">
    </pdq-input>
  </div>

  <div class="location-input-editor__field">
    <label class="location-input-editor__field-label">Text Color</label>
    <pdq-input-color
      [control]="optionsForm.get('errorMessageColor')"
      [formControl]="optionsForm.get('errorMessageColor')"
      label=""></pdq-input-color>
  </div>
</div>
